import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  productCard: {
    marginBottom: theme.spacing(2),
    borderRadius: theme.shape.borderRadius * 2,
    boxShadow: 'none',
    border: '1px solid #eee',
  },
  productCardContent: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(2),
    '&:last-child': {
      paddingBottom: theme.spacing(2),
    },
  },
  productDetails: {
    flexGrow: 1,
  },
  discountActions: {
    display: 'flex',
    alignItems: 'center',
  },
  discountChip: {
    backgroundColor: '#e8f5e9',
    color: '#00c853',
    fontWeight: 'bold',
    borderRadius: theme.shape.borderRadius,
    minWidth: 180,
    minHeight: 70,
    height: 'auto',
    width: '100%',
    '& .MuiChip-label': {
      width: '100%',
    }
  },
  chipLabelContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    whiteSpace: 'normal',
    textAlign: 'left',
    lineHeight: 1.2,
  },
  chipInnerContent: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
  },
  discountText: {
    fontWeight: 'bold',
    fontSize: '1.3em',
    color: '#017532' 
  },
  discountRule: {
    color: '#000000'
  },
  starIcon: {
    color: '#017833',
    fontSize: '2.2em',
  },
  expandedDiscountSection: {
    padding: theme.spacing(2),
    paddingTop: 0,
  },
}));